import { createContext } from "react";

const AttendanceDaysContext = createContext();

export default AttendanceDaysContext;
